import { Suspense } from 'react'
import { useSearch } from '@tanstack/react-router'

import { ListTour } from '~/boundedContext/onboarding'

import { InsertForm } from '../components/insert-form'
import { List } from '../components/list'

export const ListPage = () => {
  const { activeCardId, word } = useSearch({ from: '/_main-layout/list' })

  return (
    <>
      <InsertForm className="order-2" word={word} />
      <List activeCardId={activeCardId} className="order-1 min-h-0 grow" />
      <Suspense fallback={null}>
        <ListTour />
      </Suspense>
    </>
  )
}
